import React, { Component } from 'react';
import { BarChart, Bar, XAxis, LabelList, Tooltip } from 'recharts'
import 'react-table/react-table.css'
import Modal from 'react-responsive-modal'
import ReactTable from 'react-table'
import { observer } from 'mobx-react';
import matchSorter from 'match-sorter';
import EditDirectory from './ToEditDirectory';

const DirectoryScreen = observer( class DirectoryScreen extends Component {

  constructor() {
    super()

    this.state = {
      modal: false,
      toEdit: null
    }

    this.readImage = this.readImage.bind(this);
    this.engageModal = this.engageModal.bind(this);
  }

  componentDidMount() {
    console.log('directory props', this.props);
    let { myStores } = this.props;
    //  initiateFetch
    myStores.mainStore.fetchDirectory();
  }

  readImage(e,row){

    console.log(e);
    console.log(e.target.files);
    let { myStores } = this.props;
    let { mainStore } = myStores;

    let files = e.target.files
    let imageUrl = null
    let downloadURL = null

    // stop everything if cancel was clicked and no image
    if(files.length <= 0){
      return
    }


    // if user changes the file grab the recent file
    let file =  files.length > 0 ? files[files.length -1]
                                   : files[0]

    let imageFile = file

    var reader = new FileReader();
    reader.onload = function(e){

      var img = new Image()

      img.onload = function(){

        var canvas = document.createElement("canvas");

        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var MAX_WIDTH = 720;
        var MAX_HEIGHT = 720;
        var width = img.width;
        var height = img.height;

        if (width > height) {

          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }

        } else {

          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }

        }

        canvas.width = width;
        canvas.height = height;
        ctx = canvas.getContext("2d");
        ctx.drawImage(img,0,0,width,height);

        var dataurl = canvas.toDataURL();
				var imageData = dataurl.split(',')[1];

        let filename = row.original.business + row.original.phone;

				var functionUrl = "https://us-central1-funily-deals.cloudfunctions.net/uploadPromoImage";

				var options = {
					method: "POST",
					body: JSON.stringify({
						title: filename,
						data: imageData
					})
				}

				//  FETCH IMAGE URL
				fetch(functionUrl,options)
				.then(res => res.json())
				.then(function (json) {
          console.log(json);
          let downloadURL = json.url;
          let directory = row.original;
          directory.imageUrl = downloadURL;
          mainStore.updateDirectory(directory);

				}.bind(this))
				.catch(err => console.log(err));

      }.bind(this) // image on load

        img.src = e.target.result

    }.bind(this) // reader.onload

      reader.readAsDataURL(file)

  }

  engageModal(objToEdit) {
    this.setState({
      toEdit: objToEdit,
      modal: !this.state.modal
    })
  }

  render() {
    let { myStores } = this.props;
    let { mainStore } = myStores;
    let columns = [
      {
        Header: "Directory Title",
        accessor: 'business',
        width: 150,
        filterable: true,
        filterMethod: (filter,rows) =>
	            	matchSorter(rows, filter.value, { keys: ['business'] }),
	          	filterAll: true
      },
      {
        Header: 'Image?',
        accessor: 'imageUrl',
        width: 100,
        Cell: row => (<p>{
          row.original.hasOwnProperty('imageUrl') && row.original.imageUrl ?
          "TRUE"
          : "FALSE" }</p>
        ),
        filterable: true,
        filterMethod: (filter,rows) =>
	            	matchSorter(rows, filter.value, { keys: ['imageUrl'] }),
	          	filterAll: true
      },
      // {
      //   Header: 'Add Image',
      //   width: 150,
      //   Cell: row => (<input type="file" onChange={(e) => this.readImage(e,row)} />),
			// 	filterable: false
      // },
      {
        width: 150,
        Cell: row => (<div>
          {
            row.original.hasOwnProperty('imageUrl') && row.original.imageUrl ?
            <img src={ row.original.imageUrl } style={ styles.img } />
            : <p>No Image</p>
          }
          </div>
        ),
        filterable: false
      },
      {
        Cell: row => (<button className='btn btn-primary' onClick={() => this.engageModal(row.original) }>Edit</button>),
				filterable: false
      }

    ]
    return (
      <div style={styles.container}>
        <h1>Directory</h1>

      {

        mainStore.loadingDirectory ?
        <h1>Loading...</h1>

        :

        <ReactTable
          data={mainStore.directory.slice()}
          filterable
          columns={columns}
          className="-striped -highlight"
          defaultPageSize={50}
        />

      }

      <Modal
        styles={styles.modal}
        open={this.state.modal}
        onClose={this.engageModal}
        animationDuration={1000}
        center
      >
          <EditDirectory
            { ...this.props }
            close={ this.engageModal }
            directory={ this.state.toEdit }
          />
      </Modal>

      </div>
    );
  }
})

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 200
  },
  img: {
    height: "150px",
    width: "150px"
  },
  modal: {
    paddingTop: 250
  }
}

export default DirectoryScreen



// WEBPACK FOOTER //
// ./src/components/admin/directory.screen.js